<i18n>
[
    "reviews__sizeWorn--label",
    "reviews__colorWorn--label",
    "reviews__runsSmall--label",
    "reviews__trueToSize--label",
    "reviews__runsLarge--label",
    "profile__height--label",
    "profile__weight--label",
    "profile__pounds--label",
    "profile__bust--label",
    "profile__age--label",
    "profile__bodyType--label",
    "profile__bodyType--apple",
    "profile__bodyType--pear",
    "profile__bodyType--hourGlass",
    "profile__bodyType--invertedTriangle",
    "profile__bodyType--stringNarrow",
    "profile__blankBodyShape--label",
]
</i18n>

<template>
    <div
        :class="{
            'c-product-review-user-info': true,
            'c-product-review-user-info--carousel': cardType === PRODUCT_REVIEW_CARD_REVIEW_DETAILS,
        }"
    >
        <h5
            v-if="profile.username"
            class="c-product-review-user-info__username u-spacer--1pt5"
        >
            {{ profile.username }}
        </h5>
        <div
            :class="{
                'c-product-review-user-info__details-container': true,
                'c-product-review-user-info__details-container--carousel': cardType ===
                    PRODUCT_REVIEW_CARD_REVIEW_DETAILS,
            }"
        >
            <template v-if="leftColumnReviewData.length">
                <div class="c-product-review-user-info__item">
                    <p
                        v-for="review of leftColumnReviewData"
                        :key="review.label"
                        class="o-text--caption c-product-review-user-info__details"
                    >
                        <span class="u-text--gray">
                            {{ review.label }}
                        </span>
                        {{ review.value }}
                    </p>
                </div>
            </template>
            <template v-if="rightColumnReviewData.length">
                <div class="c-product-review-user-info__item">
                    <p
                        v-for="review of rightColumnReviewData"
                        :key="review.label"
                        class="o-text--caption c-product-review-user-info__details"
                    >
                        <span class="u-text--gray">
                            {{ review.label }}
                        </span>
                        {{ review.value }}
                    </p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { get } from 'lodash-es';

import {
    PRODUCT_REVIEW_CARD_REVIEW_DETAILS,
    PRODUCT_REVIEW_CARD_REVIEW_LIST,
} from '~routes/product/js/product-constants';
import { BODY_TYPE_LABELS } from '~modules/core/js/constants';

export default {
    name: 'ProductReviewUserInfo',
    props: {
        profile: {
            type: Object,
            required: true,
        },
        sizeWorn: {
            type: String,
            required: true,
        },
        colorWorn: {
            type: String,
            required: true,
        },
        cardType: {
            type: String,
            default: PRODUCT_REVIEW_CARD_REVIEW_LIST,
        },
    },
    data: () => ({
        BODY_TYPE_LABELS,
        PRODUCT_REVIEW_CARD_REVIEW_DETAILS,
        PRODUCT_REVIEW_CARD_REVIEW_LIST,
    }),
    computed: {
        height() {
            let height = `${get(this.profile.customaryHeight, 'ft')}'`;
            if (get(this.profile.customaryHeight, 'in')) {
                height += `${this.profile.customaryHeight.in}"`;
            }
            return height;
        },
        formattedReviewData() {
            const reviewData = [
                {
                    isOn: Boolean(this.sizeWorn),
                    label: `${this.$t('reviews__sizeWorn--label')}:`,
                    value: this.sizeWorn,
                },
                {
                    isOn: Boolean(this.colorWorn),
                    label: `${this.$t('reviews__colorWorn--label')}:`,
                    value: this.truncatedColorName.toLowerCase(),
                },
                {
                    isOn: Boolean(this.profile.customaryHeight),
                    label: `${this.$t('profile__height--label')}:`,
                    value: this.height,
                },
                {
                    isOn: Boolean(this.profile.customaryWeight),
                    label: `${this.$t('profile__weight--label')}:`,
                    value: `${get(this.profile.customaryWeight, 'lbs')} ${this.$t('profile__pounds--label')}`,
                },
                {
                    isOn: Boolean(this.profile.bodyType),
                    label: `${this.$t('profile__bodyType--label')}:`,
                    value: this.$t(BODY_TYPE_LABELS[get(this.profile, 'bodyType')] || 'profile__blankBodyShape--label'),
                },
                {
                    isOn: Boolean(this.profile.braSize),
                    label: `${this.$t('profile__bust--label')}:`,
                    value: `${get(this.profile.braSize, 'band')}${get(this.profile.braSize, 'cup')}`,
                },
                {
                    isOn: Boolean(this.profile.age),
                    label: `${this.$t('profile__age--label')}:`,
                    value: get(this.profile, 'age'),
                },
            ];

            return reviewData.filter(e => e.isOn);
        },
        leftColumnReviewData() {
            return this.formattedReviewData.slice(0, Math.ceil(this.formattedReviewData.length / 2));
        },
        rightColumnReviewData() {
            return this.formattedReviewData.slice(Math.ceil(this.formattedReviewData.length / 2),
                this.formattedReviewData.length);
        },
        truncatedColorName() {
            return this.colorWorn.length > 10 ? `${this.colorWorn.substring(0, 10)}...` : this.colorWorn;
        },
    },
};
</script>

<style lang="scss">
    .c-product-review-user-info {
        &--carousel {
            margin-bottom: $nu-spacer-4;

            @include breakpoint(medium) {
                margin-bottom: $nu-spacer-3;
            }
        }

        &__details-container {
            display: flex;
            flex-direction: row;

            @include breakpoint(medium) {
                flex-direction: column;
            }

            &--carousel {
                @include breakpoint(medium) {
                    flex-direction: row;
                }
            }
        }

        &__item {
            flex: 0 50%;

            @include breakpoint(medium) {
                flex: 1;
            }
        }

        &__details, &__username {
            @include ellipsize;
        }

        &__details {
            margin-bottom: $nu-spacer-1;
            text-transform: capitalize;
        }
    }
</style>
